import React, { useEffect, useState } from 'react';
import api, { isSupervisorRole, getCurrentUser } from '../api/expoApi';
import HubSelector from '../components/HubSelector';

export default function ActivityLogViewer() {
    const user = getCurrentUser();
    const isSupervisor = isSupervisorRole(user?.role);
    const [logs, setLogs] = useState([]);
    const [actions, setActions] = useState([]);
    const [entities, setEntities] = useState([]);
    const [filter, setFilter] = useState({
        actor_id: '', hub_id: '', action: '', entity_type: '',
        from_date: '', to_date: ''
    });
    const [selected, setSelected] = useState(null);

    const load = async () => {
        try {
            const r = await api.get('/activity-log', { params: filter });
            setLogs(r.data?.data || []);
        } catch (e) { console.error(e); }
    };

    const loadMeta = async () => {
        try {
            const [a, e] = await Promise.all([
                api.get('/activity-log/actions'),
                api.get('/activity-log/entities')
            ]);
            setActions(a.data?.data || []);
            setEntities(e.data?.data || []);
        } catch (err) { console.error(err); }
    };

    useEffect(() => { loadMeta(); }, []);
    useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

    if (!isSupervisor) return <div style={{ padding: 24 }}><h1>Access denied</h1><p>This page is for supervisors only.</p></div>;

    const exportCsv = () => {
        const params = new URLSearchParams(filter).toString();
        const token = localStorage.getItem('accessToken');
        // Use fetch + blob for authorized download
        fetch(`/api/v1/activity-log/export.csv?${params}`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(r => r.blob()).then(blob => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `activity-log-${new Date().toISOString().slice(0, 10)}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        });
    };

    return (
        <div style={{ padding: 24 }}>
            <h1>Activity Log Viewer</h1>

            <div style={{ background: '#f8f9fa', padding: 12, borderRadius: 6, marginBottom: 12, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 8 }}>
                <HubSelector value={filter.hub_id} onChange={(v) => setFilter({...filter, hub_id: v || ''})} />
                <select value={filter.action} onChange={(e) => setFilter({...filter, action: e.target.value})}>
                    <option value="">All actions</option>
                    {actions.map((a) => <option key={a} value={a}>{a}</option>)}
                </select>
                <select value={filter.entity_type} onChange={(e) => setFilter({...filter, entity_type: e.target.value})}>
                    <option value="">All entities</option>
                    {entities.map((e) => <option key={e} value={e}>{e}</option>)}
                </select>
                <input type="date" value={filter.from_date} onChange={(e) => setFilter({...filter, from_date: e.target.value})} placeholder="From" />
                <input type="date" value={filter.to_date} onChange={(e) => setFilter({...filter, to_date: e.target.value})} placeholder="To" />
                <button onClick={exportCsv}>Export CSV</button>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
                <thead><tr><th>When</th><th>Actor</th><th>Action</th><th>Entity</th><th>Hub</th><th>IP</th><th></th></tr></thead>
                <tbody>
                    {logs.length === 0 && <tr><td colSpan="7" style={{ textAlign: 'center', padding: 16 }}>No activity</td></tr>}
                    {logs.map((l) => (
                        <tr key={l.log_id} onClick={() => setSelected(l)} style={{ cursor: 'pointer' }}>
                            <td>{new Date(l.created_at).toLocaleString()}</td>
                            <td>{l.actor_email}<br/><small>{l.actor_role}</small></td>
                            <td><code>{l.action}</code></td>
                            <td>{l.entity_type} {l.entity_id && <small>· {l.entity_id}</small>}</td>
                            <td>{l.hub_id || '—'}</td>
                            <td><small>{l.ip_address}</small></td>
                            <td>👁</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {selected && (
                <div style={{
                    position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }} onClick={() => setSelected(null)}>
                    <div style={{ background: '#fff', maxWidth: 700, width: '90%', maxHeight: '80vh', overflow: 'auto', padding: 24, borderRadius: 8 }} onClick={(e) => e.stopPropagation()}>
                        <h3>Activity Detail</h3>
                        <p><strong>{selected.action}</strong> by {selected.actor_email} at {new Date(selected.created_at).toLocaleString()}</p>
                        <h4>Before</h4>
                        <pre style={{ background: '#f8f9fa', padding: 12, fontSize: '.85rem', overflow: 'auto' }}>{JSON.stringify(selected.before_state, null, 2)}</pre>
                        <h4>After</h4>
                        <pre style={{ background: '#f8f9fa', padding: 12, fontSize: '.85rem', overflow: 'auto' }}>{JSON.stringify(selected.after_state, null, 2)}</pre>
                        <h4>Metadata</h4>
                        <pre style={{ background: '#f8f9fa', padding: 12, fontSize: '.85rem', overflow: 'auto' }}>{JSON.stringify(selected.metadata, null, 2)}</pre>
                        <button onClick={() => setSelected(null)} style={{ marginTop: 12 }}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
}
